module.exports = __webpack_public_path__ + "img/magento-migration_medium.5a410058.jpg";